import { useContainerBreakPoint } from '@ui/hooks/useContainerBreakPoint';

import { TRADE_PAGE_BODY_ID } from '../constants';

export const useIsTradePageContainerDesktop = () => {
  return useContainerBreakPoint({
    containerQuerySelector: "html",
    breakpointChecker(size, breakpointNumbers) {
      return size.width >= breakpointNumbers.desktop;
    },
  });
};
